import { render, staticRenderFns } from "./PropertyNoticeInfo.vue?vue&type=template&id=c6f2f170&scoped=true&"
import script from "./PropertyNoticeInfo.vue?vue&type=script&lang=js&"
export * from "./PropertyNoticeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f2f170",
  null
  
)

export default component.exports